import React, { useState, useEffect } from 'react'
import Scrollbars from 'react-scrollbars-custom'
import { DeletedReport, DuplicateReport, PublishedReport } from '../../../common/types/api/report'
import type ReportsList from '../../../common/types/api/reportsList'
import Card from './Card'
import Header from './Header'
import styled from 'styled-components'
import { 
    FilterOption, 
    ReportListHeaders, 
    SortOption, 
    handleFilterReportList, 
    handleSorterReportList,
    buildReportListFilters
} from './helper'


interface Props {
    getReports: () => Promise<ReportsList>
    deleteReports: (uid: string) => Promise<DeletedReport>
    publishReports: (uid: string) => Promise<PublishedReport>
    duplicateReports: (uid: string, newTitle: string) => Promise<DuplicateReport>
}
export default function ReportList({
    getReports,
    deleteReports,
    publishReports,
    duplicateReports
}: Props): JSX.Element {
    const [reports, setReports] = useState<ReportsList>()

    const [selectedFilters, setSelectedFilters] = useState<FilterOption[]>([])

    const [selectedSorter, setSelectedSorter] = useState<SortOption>({
        field: ReportListHeaders.REPORT_NAME,
        reverse: false
    })

    const updateReports = async (): Promise<void> => {
        const newReports = await getReports()
        if (newReports) setReports(newReports)
    }
    // TODO: MOVE TO REDUCER
    const actionDelete = (uid: string): void => {
        deleteReports(uid)
            .then(reportDeleted => {
                // console.log(reportDeleted.deleted ? 'sucess' : 'error', ': method delete report', uid)
            })
            .finally(() => {
                updateReports()
            })
    }
    const actionPublish = (uid: string): void => {
        publishReports(uid)
            .then(reportPublished => {
                // console.log(reportPublished.success ? 'sucess' : 'error')
                // console.log(reportPublished.error)
            })
            .finally(() => {
                updateReports()
            })
    }

    const actionDuplicate = (uid: string, newTitle: string): void => {
        duplicateReports(uid, newTitle)
            .then(duplicateReport => {
                // console.log(reportPublished.success ? 'sucess' : 'error')
                // console.log(reportPublished.error)
            })
            .finally(() => {
                updateReports()
            })
    }

    useEffect(() => {
        updateReports()
        // TODO: RESOLVE LATER
    }, [])

    if (!reports) return <div>loading...</div>

    if (!reports.success) return <div>error !</div>

    return (
        <StyledReportListContainer 
            style={{height: (document.getElementById("report-app-body")?.clientHeight *0.95) + "px"}}
            >
            <Header 
                selectedFilters={selectedFilters}
                selectedSorter={selectedSorter}
                onChangeFilters={setSelectedFilters}
                onChangeSorter={setSelectedSorter}
                filterOptions={buildReportListFilters(reports?.configs)}
            />
            <div className="report-list-body-container">
                {reports?.configs?.filter((report) => handleFilterReportList(report, selectedFilters))
                .sort((a, b) => handleSorterReportList(a, b, selectedSorter)).map(report => (
                    <Card
                        report={report}
                        key={report.uid}
                        actionDelete={actionDelete}
                        actionPublish={actionPublish}
                        actionDuplicate={actionDuplicate}
                    />
                ))}
            </div>
        </StyledReportListContainer>
    )
}

const StyledReportListContainer = styled.div`
    display: flex;
    flex-direction: column;
    * {
        scrollbar-width: auto;
        scrollbar-color: #c4c4c4 #ffffff;
    }
    *::-webkit-scrollbar {
        width: 12px;
    }

    *::-webkit-scrollbar-track {
        background: #ffffff;
    }

    *::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme['gray-400']};
        border-radius: 6px;
        border: 2px solid ${({ theme }) => theme['gray-0']};
    }
    .report-list-body-container{
        overflow-y: auto;
        .ScrollbarsCustom-Track,
        ScrollbarsCustom-TrackY {
            background: rgb(255, 255, 255) none repeat scroll 0% 0% !important;
            .ScrollbarsCustom-Thumb,
            ScrollbarsCustom-ThumbY {
                background: ${({ theme }) => theme['gray-400']};
            }
        }
    }
`
